import React from "react";
import { Link } from "react-router-dom"; // For navigation back to home

export const ErrorPage = () => {
  return (
    <main>
    <header id="error-page">
      <div className="intro responsive-img">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-8 col-md-offset-2 intro-text text-center">
                <h1>
                  Oops! Page Not Found
                  <span></span>
                </h1>
                <p>The page you're looking for doesn't exist or may have been moved.</p>
                <br />
                <Link to="/" className="btn btn-custom btn-lg page-scroll" aria-label="Go Back to Home">
                  Go Back Home
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
      <footer id="footer">
        <div className="container text-center">
          <p>
            &copy; 2024 Mo2Cloud. All Rights Reserved.
          </p>
        </div>
      </footer>
    </main>
  );
};
